import React, { Component } from "react";
import axios from "axios";
import { Row, Col } from "react-grid-system";
import Avatar from "react-avatar";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import { Carousel } from "react-responsive-carousel";
import ReactPlayer from "react-player";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import $ from "jquery";

class RealCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      qrkey: props.match.params.qrkey,
      defaultinfo: {
        use: 1,
        del: 0,
        title: "",
        contents: "",
        img1: "",
        classify: "",
      },
      mediaslideridx: 0,
      medialist: [],
      buttonlist: [],
      opengallery: true,
    };
  }

  componentDidMount() {
    this.getRealCodeInfo(this.state.qrkey);

    $(document).ready(function () {
      console.log("");
      console.log("[window ready] : [start]");
      console.log("");

      // [현재 접속된 url 정보 및 접속 브라우저 확인]
      // [카카오톡 인앱 브라우저 >> 안드로이드 모바일 기종 인 경우 >> 크롬 브라우저 이동 실시]
      var Url = window.location.href;
      var Agent = navigator.userAgent.toLowerCase();
      console.log("");
      console.log("[window ready] : [접속 Url] : " + Url);
      console.log("[window ready] : [접속 Agent] : " + Agent);
      console.log("");
      //alert(Agent);

      if (Agent.includes("kakao")) {
        // 카카오 브라우저로 실행 시킨 경우
        // 먼저, 카카오 인앱 브라우저 닫기
        window.location.href = "kakaotalk://inappbrowser/close";
        if (navigator.userAgent.match(/iPhone|iPad/i)) {
          // 아이폰 접속 경우
          console.log("");
          console.log("[window ready] : [접속 모바일] : " + "[아이폰]");
          console.log("");
        } else {
          // 안드로이드 접속 경우
          console.log("");
          console.log("[window ready] : [접속 모바일] : " + "[안드로이드]");
          console.log("");
          // 크롬으로 새창 열기
          window.location.href =
            "intent://" +
            window.location.href.replace(/https?:\/\//i, "") +
            "#Intent;scheme=http;package=com.android.chrome;end";
        }
      }
    });
  }

  getRealCodeInfo(qrkey) {
    console.log(qrkey);
    var _url = "https://happyqr.net/api/starname/api/getRealCodeInfo";

    if (
      qrkey ==
        "B8C3E18804DD9E5FCFDEED1F37B57A9FABC4F774445865C5B1FCDBE1427B215E" ||
      qrkey ==
        "29853B9D839AB95ED5A48C22D249C20F7E6BDA6332D02CCFFEAA825BC2E56FA8" ||
      qrkey ==
        "13BC030C35506076E3EE7C9661750B26C3CEEB882E4B4D5FAD92EFAE5753FC99" ||
      qrkey ==
        "0AC00C3FBC2AE1E30206A3F06E45F8152BC15E9D64A8404EC3CC21D369CA3FF6" ||
      qrkey ==
        "49ABE9060BF880439B55A7FA227E5468764FEB313865D05B2D8C307DEB0FB1BC" ||
      qrkey ==
        "5ED5365F881B8169D590988DC0369B70CF1A276722AA0BE89E10F0785CF5BBC9" ||
      qrkey ==
        "AF379CFEF614484D3A684D2E199EED4F27244B2CD5CC34BFDDA05FAD21F8518A" ||
      qrkey ==
        "6790D5C430790DE3DA5D6A19AF021810C63EAA9D44E8406ABC1534EB4A1ADD5B" ||
      qrkey ==
        "15F0D338D9FDDAE7CBE0EDDABC8A989614BF9FD06BE467640AB306A3C1783298" ||
      qrkey ==
        "C7B4311B62A3943D3AEDD83EC6F44D44EB9902D63084D53F8A61E991EDDC987D" ||
      qrkey ==
        "74A47413C90B741D6A70982EF577FACAADCB02CADB4F9572AE0386453C863FA6" ||
      qrkey ==
        "5ED5365F881B8169D590988DC0369B70CF1A276722AA0BE89E10F0785CF5BBC9" ||
      qrkey ==
        "E3600633D24072A8E9EFB7704A33CD974202F14B53DDB69C14CC49A08B5DC287"
    ) {
      _url = "https://realscaner.com/api/starname/api/getRealCodeInfo";
    }
    axios
      .post(_url, {
        qrkey: qrkey,
      })
      .then((data) => {
        if (data.data.code == 200) {
          console.log(data.data);
          this.setState({
            defaultinfo: data.data.info,
            medialist: data.data.medialist,
            buttonlist: data.data.buttons,
          });
        }
      })
      .catch((error) => {
        console.log("error : ", error);
      });
  }

  renderHeader() {
    return (
      <img
        src={"/rc_logo_white.png"}
        style={{ paddingTop: "2%", height: "75%" }}
      ></img>
    );
  }

  renderDefaultInfo() {
    const info = this.state.defaultinfo;
    return (
      <div style={{ width: "100%", padding: "5px" }}>
        <Row style={{ margin: "0px" }}>
          <Avatar src={info.img1} size="60" round="5px"></Avatar>
          <Col>
            <div style={{ fontSize: "revert", fontWeight: "bolder" }}>
              {info.title}
            </div>
            <div style={{ fontSize: "small" }}>{info.contents}</div>
          </Col>
        </Row>
      </div>
    );
  }

  onClickButton(item) {
    if (item.type === "LINK") {
      window.location.href = item.desc;
    } else if (item.type === "CALL") {
      window.location.href = "tel:" + item.desc;
    } else if (item.type === "MAP") {
      window.location.href =
        "https://map.naver.com/v5/search/" + item.desc.replace(/ /gi, "+");
    } else if (item.type === "GALLERY") {
      window.location.href = "/gallery/" + item.no;
    } else if (item.type === "PDF/VIDEO") {
      window.open(item.desc);
    } else if (item.type === "KAKAO") {
      console.log("onClick kakao realcode");
    }
  }

  onCloseGalleryDialog = () => {
    this.setState({ opengallery: false });
  };

  onChangeCarousel = (index) => {
    console.log(index);
    this.setState({ mediaslideridx: index });
  };

  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows: false,
    };

    var gallery_settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    return (
      <div className="app">
        {/*
        <div className="header" style={{ backgroundColor: "#fc4700" }}>
          {this.renderHeader()}
        </div>
        */}
        <div className="main">
          {this.renderDefaultInfo()}
          <div
            style={{
              flex: 1,
              backgroundColor: "white",
              alignItems: "center",
              display: "flex",
            }}
          >
            <Carousel
              showThumbs={false}
              showArrows={false}
              swipeScrollTolerance={30}
              showStatus={false}
              preventMovementUntilSwipeScrollTolerance={true}
              onChange={this.onChangeCarousel}
              swipeable={true}
              selectedItem={this.state.mediaslideridx}
            >
              {this.state.medialist.map((item, index) => {
                if (item.type == "VOD") {
                  if (this.state.mediaslideridx == index) {
                    return (
                      <div key={item.no} style={{ width: "100%" }}>
                        <ReactPlayer
                          width="100%"
                          autoPlay={false}
                          playing={true}
                          controls={true}
                          url={item.imgurl}
                        />
                      </div>
                    );
                  } else {
                    return (
                      <div key={item.no} style={{ width: "100%" }}>
                        <ReactPlayer
                          width="100%"
                          playing={false}
                          autoPlay={false}
                          controls={true}
                          url={item.imgurl}
                        />
                      </div>
                    );
                  }
                } else if (item.type == "IMG") {
                  return (
                    <div key={item.no} style={{ width: "100%" }}>
                      <img src={item.imgurl} />
                    </div>
                  );
                }
              })}
            </Carousel>
          </div>
        </div>
        <div
          className="footer"
          style={{
            paddingTop: "10px",
            paddingBottom: "5px",
            borderTop: "1px solid #eee",
          }}
        >
          <Slider {...settings}>
            {/*you can add styling for your button*/}
            {this.state.buttonlist.map((item, index) => {
              return (
                <Col key={index} onClick={() => this.onClickButton(item)}>
                  <div
                    style={{
                      width: 80,
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      marginRight: "2px",
                      marginLeft: "2px",
                    }}
                  >
                    <img
                      src={item.iconurl}
                      style={{
                        width: 28,
                        height: 22,
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    ></img>
                  </div>
                  <div
                    style={{
                      width: 80,
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      marginRight: "2px",
                      marginLeft: "2px",
                    }}
                  >
                    <p>{item.title}</p>
                  </div>
                </Col>
              );
            })}
          </Slider>
        </div>
      </div>
    );
  }
}

export default RealCode;
